var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sfgrd-main-wrap"},[_c('tk-page',{attrs:{"page-config":_vm.objPageConfig,"obj-table":_vm.objTable,"obj-form":_vm.objSelectForm,"obj-buttons":_vm.objButtons},on:{"onSearch":_vm.queryData,"onReset":_vm.resetFields}}),_c('dialog-approval',{ref:"dialogApproval"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }